import { isAccelKey, StateNode } from "@tldraw/editor";
class Idle extends StateNode {
  static id = "idle";
  onEnter(info) {
    if (!(info?.accelKey ?? this.editor.inputs.getAccelKey())) {
      ;
      this.parent.maybeReturnToOriginatingTool();
    }
  }
  onKeyUp(info) {
    if (!isAccelKey(info)) {
      ;
      this.parent.maybeReturnToOriginatingTool();
    }
  }
  onPointerDown(info) {
    this.parent.transition("pointing", info);
  }
  onCancel() {
    const onInteractionEnd = this.parent.info.onInteractionEnd;
    this.editor.setCurrentTool(onInteractionEnd ?? "select");
  }
}
export {
  Idle
};
//# sourceMappingURL=Idle.mjs.map
